module.exports = {
    created: {
        description: 'SHIPMENT_CREATED_DESCRIPTION',
    },
    en_route: {
        description: 'SHIPMENT_EN_ROUTE_DESCRIPTION',
    },
    arrived: {
        description: 'SHIPMENT_ARRIVED_DESCRIPTION',
    },
    scheduled: {
        description: 'SHIPMENT_SCHEDULED_DESCRIPTION',
    },
    exposed: {
        description: 'SHIPMENT_EXPOSED_DESCRIPTION',
    },
    needs_appt: {
        description: 'SHIPMENT_NEEDS_APPT_DESCRIPTION'
    },
    accepted: {
        description: 'SHIPMENT_ACCEPTED_DESCRIPTION',
    },
    in_progress: {
        description: 'SHIPMENT_IN_PROGRESS_DESCRIPTION',
    },
    job_closed: {
        description: 'SHIPMENT_CLOSED_DESCRIPTION',
    },
};
